var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHubIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.29873V18.6197H18.1096V1.37753H1.89036V18.6197H18.1096V20H0V1.29873C0 0.581434 0.797881 0 1.78595 0H18.214C19.2021 0 20 0.581434 20 1.29873Z",
    fill: "#535C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 2.79028H3.74365V4.16782H16.253V2.79028Z",
    fill: "#535C64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 5.26831H3.74365V6.64584H16.253V5.26831Z",
    fill: "#535C64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 7.74634H3.74365V9.12385H16.253V7.74634Z",
    fill: "#535C64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 10.2241H3.74365V11.6016H16.253V10.2241Z",
    fill: "#535C64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99646 12.7021H3.74365V14.0797H9.99646V12.7021Z",
    fill: "#535C64"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.253 15.1799H3.74365V16.5575H16.253V15.1799Z",
    fill: "#535C64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubIcon);
export default __webpack_public_path__ + "static/media/hub-icon.77bff39cc0b2e692562e4959471ad3b5.svg";
export { ForwardRef as ReactComponent };